/**
 * sessionSnapshotter.js
 * Multi-Window Browser Tab Session Snapshotter Engine
 * 
 * Captures, serializes, and restores dated workspace tab sets and window sessions
 * with full folder hierarchy and tag preservation.
 */

const STORAGE_KEY = 'memark_workspace_snapshots';

export function getSnapshots() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw);
  } catch (e) {
    return [];
  }
}

export function saveSnapshots(snapshots) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshots));
  } catch (e) {
    console.error('Failed to save snapshots', e);
  }
}

export function createSnapshot(name, bookmarks = [], folders = []) {
  const snapshots = getSnapshots();
  const dateStr = new Date().toLocaleString();
  const newSnapshot = {
    id: 'snap_' + Date.now(),
    name: name || `Workspace Snapshot (${dateStr})`,
    timestamp: new Date().toISOString(),
    itemCount: bookmarks.length,
    folderCount: folders.length,
    bookmarks,
    folders,
  };

  const updated = [newSnapshot, ...snapshots];
  saveSnapshots(updated);
  return newSnapshot;
}

export function deleteSnapshot(id) {
  const snapshots = getSnapshots();
  const updated = snapshots.filter((s) => s.id !== id);
  saveSnapshots(updated);
  return updated;
}
